import { InjectionToken } from '@angular/core';
import { NotificationConfig } from '../models/notification.interface';

export const CHAT_NOTIFICATION_CONFIG = new InjectionToken<Partial<NotificationConfig>>('ChatNotificationConfig', {
  providedIn: 'root',
  factory: () => ({
    enabled: true,
    soundEnabled: true,
    maxVisibleNotifications: 3,
    debounceMs: 1000,
    clickAction: 'navigate',
    customIcon: 'assets/images/logo.svg',
  }),
});